// src/components/Configurator/renderers/KitchenElementRenderer.jsx
import React from "react";
import { SELECTED_ELEMENT_COLOR, defaultObjectSizes, OBJECT_TYPES, DRAWING_KITCHEN_ELEMENT_FILL_COLOR, DRAWING_KITCHEN_ELEMENT_STROKE_COLOR } from "../configuratorConstants";

const KitchenElementRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness,
  placementSideFactor, // Should be 1 or -1
}) => {
  const kitchenDefaults = defaultObjectSizes[OBJECT_TYPES.KITCHEN_ELEMENT];
  const elementVisualWidthM = element.width || kitchenDefaults.width;
  const elementPlanDepthM = element.depth || kitchenDefaults.depth;

  const elementVisualWidthPx = elementVisualWidthM * scale;
  const elementPlanDepthPx = elementPlanDepthM * scale;
  const wallThicknessPx = wallThickness * scale;

  // Position the center of the kitchen element's depth relative to the wall surface
  const yOffset = placementSideFactor * ( (wallThicknessPx / 2) + (elementPlanDepthPx / 2) );

  const rectStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : DRAWING_KITCHEN_ELEMENT_FILL_COLOR,
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : DRAWING_KITCHEN_ELEMENT_STROKE_COLOR,
    strokeWidth: isSelected ? 1.5 / (scale / 50) : 1 / (scale / 50),
  };

  const groupTransform = placementSideFactor === 1 ? "scale(1, -1)" : "";

  return (
    <g transform={`translate(0, ${yOffset})`}>
      <g transform={groupTransform}>
        <rect
          x={-elementVisualWidthPx / 2}
          y={-elementPlanDepthPx / 2} // Center its depth
          width={elementVisualWidthPx}
          height={elementPlanDepthPx} // Show its depth on the plan
          style={rectStyle}
        />
      </g>
    </g>
  );
};

export default React.memo(KitchenElementRenderer);